import { Typography } from '@mui/material';
import { TextFieldProps, useRecordContext } from 'react-admin';
import { locale, numberFormatConfiguration } from './numberFormatConfiguration';
import get from 'lodash/get';
import { SxProps } from '@mui/system';

// Type hack: using 'any' to bypass type compatibility issues
interface Props extends TextFieldProps {
  sx?: any; // Using 'any' to bypass type checking for sx prop
}

export const QuickbooksPriceField = (props: Props) => {
  const record = useRecordContext();

  const price = Intl.NumberFormat(locale, numberFormatConfiguration).format(
    record && props.source && get(record, props.source)
      ? get(record, props.source)
      : 0
  );

  // Using type assertion to bypass type checking for props
  return <Typography {...(props as any)}>{price}</Typography>;
};
